export default `
  mutation saveGitHubToken($code: String!) {
    saveGitHubToken(code: $code) {
      success
      errorText
      resData {
        githubAccounts {
          login
          avatar
        }
      }
    }
  }
`
